import { useMutation } from 'react-query';
import { lovageApi } from 'src/axios';

export interface PaymentDetailsPortal {
  portal_url: string;
}

export const createPaymentDetailsPortal = (data: {}) => {
  console.log('createPaymentDetailsPortal');
  return lovageApi
    .post<PaymentDetailsPortal>(`/onboarding/billing/payment-information`)
    .then((res) => res.data);
};

export default function useCreatePaymentDetailsPortal() {
  return useMutation(createPaymentDetailsPortal);
}
